/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import H4 from 'UIComponents/elements/headings/H4';
import UICardSection from 'UIComponents/card/UICardSection';
import UIFlex from 'UIComponents/layout/UIFlex';
import Rating from 'marketplace-ui-reviews/components/Rating';
import ProfileListing from 'ecosystem-marketplace-core/records/ProfileListing';
import LoadingWrapper from 'ecosystem-marketplace-core/components/LoadingWrapper';
import MediaSize from 'ecosystem-marketplace-core/components/layout/MediaSize';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import ReviewWizard from './ReviewWizard';
import ProfileCardWrapper from './ProfileCardWrapper';
import WriteReviewButton from './WriteReviewButton';
import ReviewsCardBody from './ReviewsCardBody';
import { getProfileReviewabilityRequestState } from '../../selectors/profile';
import { getProfileReviewStats } from '../../actions/ReviewActions';
import { getReviewStatsRequestState } from '../../selectors/reviews';
import { getIsPublicApp } from '../../selectors/app';
import { replace } from '../../utils/history';
const I18N_BASE = 'ecosystem-marketplace-solutions-ui.profile.reviews';

const ReviewsCard = ({
  isPreview,
  onTrackInteraction,
  profileListing,
  reviewButtonRef,
  scrollToTabSection
}) => {
  const {
    pathname
  } = useLocation();
  const {
    id: profileId,
    name,
    reviewSummary,
    slug
  } = profileListing;
  const isReviewLink = pathname.includes('/write-review');
  const [wizardOpen, setWizardOpen] = useState(isReviewLink);
  const [reviewPending, setReviewPending] = useState(false);
  const isPublicApp = useSelector(getIsPublicApp);
  const reviewabilityRequestStatus = useSelector(getProfileReviewabilityRequestState);
  const reviewabilityStatus = isPublicApp || isPreview ? RequestState.SUCCEEDED : reviewabilityRequestStatus;
  const dispatch = useDispatch();
  const reviewStatsRequestState = useSelector(getReviewStatsRequestState);
  useEffect(() => {
    dispatch(getProfileReviewStats(profileId));
  }, [dispatch, profileId]);

  const renderedReviewButton = /*#__PURE__*/_jsx(WriteReviewButton, {
    isPreview: isPreview,
    isPublicApp: isPublicApp,
    profileListing: profileListing,
    reviewButtonRef: reviewButtonRef,
    reviewPending: reviewPending,
    setWizardOpen: setWizardOpen,
    size: "md"
  });

  const renderedBody = useMemo(() => reviewSummary.get('reviewCount') ? /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: reviewStatsRequestState,
    children: /*#__PURE__*/_jsx(ReviewsCardBody, {
      onTrackInteraction: onTrackInteraction,
      profileListing: profileListing,
      scrollToTabSection: scrollToTabSection
    })
  }) : /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H4, {
      className: "m-top-8",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${I18N_BASE}.emptyState`
      })
    }), /*#__PURE__*/_jsx(Rating, {
      rating: 0,
      labelSize: "large",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${I18N_BASE}.reviewCount`,
        options: {
          count: 0
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-top-8",
      children: renderedReviewButton
    })]
  }), [onTrackInteraction, profileListing, renderedReviewButton, reviewSummary, reviewStatsRequestState, scrollToTabSection]);
  const renderedHeading = useMemo(() => /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H2, {
      className: "is--heading-3",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${I18N_BASE}.title`,
        options: {
          name
        }
      })
    }), reviewSummary.get('reviewCount') ? renderedReviewButton : null]
  }), [name, reviewSummary, renderedReviewButton]);
  return /*#__PURE__*/_jsxs(LoadingWrapper, {
    requestStatus: reviewabilityStatus,
    children: [/*#__PURE__*/_jsx(ProfileCardWrapper, {
      id: "reviews",
      children: /*#__PURE__*/_jsxs(UICardSection, {
        children: [/*#__PURE__*/_jsx(MediaSize, {
          minDeviceSize: "md",
          minScreenSize: "md",
          alternate: renderedHeading,
          children: /*#__PURE__*/_jsx(UIFlex, {
            justify: "between",
            children: renderedHeading
          })
        }), renderedBody]
      })
    }), wizardOpen && /*#__PURE__*/_jsx(ReviewWizard, {
      onConfirm: () => setReviewPending(true),
      onClose: () => {
        replace(`/${slug}`);
        setWizardOpen(false);
      },
      onTrackInteraction: onTrackInteraction,
      profileListing: profileListing
    })]
  });
};

ReviewsCard.propTypes = {
  isPreview: PropTypes.bool.isRequired,
  onTrackInteraction: PropTypes.func.isRequired,
  profileListing: PropTypes.instanceOf(ProfileListing),
  reviewButtonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  scrollToTabSection: PropTypes.func.isRequired
};
export default ReviewsCard;